
<div class="admin-card-container" ngbDropdown #adminDrop="ngbDropdown" [ngClass]="{'admin-card-hide': !hasItems()}">
  <div class="admin-card" id="appsCard" ngbDropdownToggle>
    <span class="fa-solid fa-user-shield" title="Admin"></span>
  </div>
  <div ngbDropdownMenu aria-labelledby="adminCard" class="admin-card-menu">

    <ng-container [ngTemplateOutlet]="templateMenuDD"
                  [ngTemplateOutletContext]="{ items : menuItems(), level: 1 }">

    </ng-container>
  </div>
</div>


<ng-template #templateMenuDD let-items="items" let-level="level">
  <ng-container *ngFor="let item of items; index as i">

    <ng-container *ngIf="item.hasChildren">

      <div *ngIf="i != 0" class="dd-menu-separator"></div>

      <div class="dd-menu-header">{{item.name}}</div>

      <ng-container [ngTemplateOutlet]="templateMenuDD"
                    [ngTemplateOutletContext]="{ items : item.children , level: level + 1 }">
      </ng-container>

    </ng-container>

    <ng-container *ngIf="!item.hasChildren">
      <ng-container *ngIf="!(item.url) || item.url.length < 1">
        <ng-container [ngTemplateOutlet]="noRoute"
                      [ngTemplateOutletContext]="{ item: item }">
        </ng-container>
      </ng-container>

      <ng-container *ngIf="(item.url) && item.url.length > 0 && isItemRouteInternal(item.url)">
        <ng-container [ngTemplateOutlet]="routeInternal"
                      [ngTemplateOutletContext]="{ item: item }">
        </ng-container>
      </ng-container>

      <ng-container *ngIf="(item.url) && item.url.length > 0 && !isItemRouteInternal(item.url)">
        <ng-container [ngTemplateOutlet]="routeExternal"
                      [ngTemplateOutletContext]="{ item: item }">
        </ng-container>
      </ng-container>
    </ng-container>

  </ng-container>
</ng-template>


<ng-template #routeInternal let-item="item">
  <a class="dd-menu-item" [routerLink]="[item.url]" ngbDropdownItem>{{item.name}}</a>
</ng-template>

<ng-template #routeExternal let-item="item">
  <a class="dd-menu-item" href="{{item.url}}" target="{{item.target}}" ngbDropdownItem>{{item.name}}</a>
</ng-template>

<ng-template #noRoute let-item="item">
  <span class="dd-menu-item" ngbDropdownItem>{{item.name}}</span>
</ng-template>
